import React from 'react';
import * as styles from './PageHeader.module.scss';
import { Button, Heading, Icon, IconList } from 'components/core';

export type BackLinkProps = {
  backLink: string;
};
export const BackLink = ({ backLink }: BackLinkProps) => {
  return (
    <Button
      to={backLink}
      className={styles.backLink}
      iconOnly
      variant="outline"
      size="md"
      aria-label="Navigate back"
    >
      <Icon icon={IconList.light.faArrowLeft} aria-hidden="true" />
    </Button>
  );
};

export type PageHeaderProps = {
  backLink?: string;
  backLinkComponent?: React.ComponentType<BackLinkProps>;
  headerText: string;
  rightContent?: () => JSX.Element | null;
};

const PageHeader = ({
  backLink,
  headerText,
  backLinkComponent = BackLink,
  rightContent,
}: PageHeaderProps) => {
  return (
    <div className={styles.pageHeader} data-testid="page-header">
      <div className={styles.container}>
        <div className={styles.leftSection}>
          {backLink && React.createElement(backLinkComponent, { backLink })}
          <Heading
            type="h1"
            component="h2"
            variant="brand"
            className={styles.headerText}
          >
            {headerText}
          </Heading>
        </div>
        <div className={styles.rightLink}>
          {rightContent ? rightContent() : null}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
